
import { authHeader } from '../../_helpers';
import axios from 'axios';

export const reportContentService = {
    reportContentHandler,
    getOrientationListHandler,
    getSlotListHandler,
};

axios.defaults.headers.common = authHeader();



function reportContentHandler(data, type) {


    const fd = {
        "orientation_id": data.orientationId
    }

    if (data.reportContent === 'orientation-text' && type === 'vpi') {


        return axios.get(`/masters/relation/group/list/create/`)
            .then(response => {
                return response;
            });
    }
    if (data.reportContent !== 'orientation-text' && type === 'vpi') {

        let token = localStorage.getItem('access_token')

        return axios.post(`/masters/orientation/${data.reportContent}/?access_token=${token}`, fd)
            .then(response => {
                return response;
            });
    }



    if (data.reportContent === 'slot-text') {
        let token = localStorage.getItem('access_token')

        const fd = {
            'slot_name': data.orientationId
        }


        return axios.post(`/masters/vvi/slot/names/list/?access_token=${token}`, fd)
            .then(response => {
                return response;
            });
    }

}

function getOrientationListHandler() {
    let token = localStorage.getItem('access_token')

    return axios.get(`/masters/orientation/list/data/?access_token=${token}`)
        .then(response => {
            return response;
        });
}

function getSlotListHandler() {
    let token = localStorage.getItem('access_token')

    return axios.get(`/masters/vvi/slot/names/list/?access_token=${token}`)
        .then(response => {
            return response;
        });
}






// WEBPACK FOOTER //
// ./src/_services/reportContent/reportContent.service.js